module.exports = __webpack_public_path__ + "static/img/img188.dcf8d0ed.png";